import {List} from 'antd';
import React, {FC} from 'react';
import {HeaderAdviceListItem} from './HeaderAdviceListItem';
import {DropdownMenuItem} from './DropdownMenu';
import {DollarOutlined, FileProtectOutlined} from '@ant-design/icons';

interface HeaderAdviceListProps {
    policiesItems: DropdownMenuItem[];
    paymentInfoItems: DropdownMenuItem[];
}

export const HeaderAdviceList: FC<HeaderAdviceListProps> = ({policiesItems, paymentInfoItems}) => {
    return (
        <List itemLayout={'horizontal'} className="list horizontal list-advice list-desc" split={false}>
            <HeaderAdviceListItem
                title={'Policies'}
                icon={<FileProtectOutlined></FileProtectOutlined>}
                items={policiesItems}
            />
            <HeaderAdviceListItem
                title={'Payment info'}
                icon={<DollarOutlined></DollarOutlined>}
                items={paymentInfoItems}
            />
        </List>
    );
};
